import { render, staticRenderFns } from "./MyAssessment_RC.vue?vue&type=template&id=6069c912&scoped=true"
import script from "./MyAssessment_RC.vue?vue&type=script&lang=js"
export * from "./MyAssessment_RC.vue?vue&type=script&lang=js"
import style0 from "./MyAssessment_RC.vue?vue&type=style&index=0&id=6069c912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069c912",
  null
  
)

export default component.exports